import { InjectionToken } from '@angular/core';
import { ThemeEnum } from '../../enums/theme/theme.enum';

export const DEFAULT_THEME = new InjectionToken<ThemeEnum>('defaultTheme');
